<script setup>
import LImpact from "@/components/layout/LImpact.vue";
import ImpactRoundedImg from "@/components/impact/ImpactRoundedImg.vue";
</script>

<template>
  <LImpact>
    <template #title> Environmental Sustainability </template>
    <template #description>
      Quantum technologies could play a crucial role in environmental sustainability by helping reduce the impact of global warming and extreme weather events through enhanced climate modeling and predictive analysis. They will also, potentially, contribute to cleaner air, water, and soil by enabling more efficient monitoring of environmental pollutants, ultimately improving public health. Furthermore, quantum innovations could optimize the integration of renewable energy into power grids, decreasing reliance on fossil fuels and driving a more sustainable energy future.
    </template>
    <template #image>
      <ImpactRoundedImg category-name="Environmental Sustainability" />
    </template>
  </LImpact>
</template>

<style scoped></style>
